import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { installAppGlobals } from "./plugins/appGlobals";

import VueHead from "vue-head";
import { createPinia, PiniaVuePlugin, setActivePinia } from "pinia";

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
setActivePinia(pinia);

import axios from "axios";
import firebase from "firebase/compat/app";
import { ensureApiSession, clearApiSession } from "./components/toLoad/api";

import "./registerServiceWorker";

import "./sass/style.css";
import "./sass/animations.css";

import { captureException, identify, initPostHog } from "./posthog";

initPostHog();

axios.interceptors.response.use(
  response => response,
  (error) => {
    const status = error.response?.status;
    const isNetworkError = !error.response;

    if (isNetworkError || (status && status >= 500))
      captureException(error, {
        flow: "axios",
        status: status || null,
        url: error.config?.url,
        method: error.config?.method,
      });

    return Promise.reject(error);
  },
);

Vue.config.errorHandler = (err, vm, info) => {
  captureException(err, {
    flow: "vue",
    component: vm?.$options?.name || vm?.$options?._componentTag || null,
    info,
  });
  if (process.env.NODE_ENV === "development") console.error(err);
};

installAppGlobals(Vue);

Vue.use(VueHead, {
  separator: "—",
  complement: "Katana",
});

Vue.config.productionTip = false;

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    identify(user.uid, {
      email: user.email,
      name: user.displayName,
    });
    ensureApiSession().catch(() => {});
  } else
    clearApiSession();

  new Vue({
    router,
    vuetify,
    pinia,
    render: h => h(App),
  }).$mount("#app");
});
